import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./Components/Dashboard";
import Header from "./Components/Header";
import Customer from "./Components/Customer";
import SidePanel from "./Components/SidePanel";
import Signin from "./Components/Signin";
import About from "./Components/About";
import Product from "./Components/Product";
import Order from "./Components/Order";
import ForgotPassword from "./Components/Forgotpassword";
import Signup from "./Components/Signup";
import VerifyCode from "./Components/Verificationcode";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem("isAuthenticated") === "true";
    });

    // ✅ Function to handle user login (works for both sign-in & sign-up)
    const handleLogin = () => {
        setIsAuthenticated(true);
        localStorage.setItem("isAuthenticated", "true");
    };

    // ✅ Function to handle logout
    const handleLogout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem("isAuthenticated"); // Clear login state
    };

    return (
        <Router>
            <div className="app">
                {isAuthenticated ? (
                    <>
                        <SidePanel onSignout={handleLogout} />
                        <div className="main-content">
                            <Header />
                            <div className="content">
                                <Routes>
                                    <Route path="/" element={<Dashboard />} />
                                    <Route path="/customer" element={<Customer />} />
                                    <Route path="/order" element={<Order />} />
                                    <Route path="/product" element={<Product />} />
                                    <Route path="/about" element={<About />} />
                                    <Route path="*" element={<Navigate to="/" />} />
                                </Routes>
                            </div>
                        </div>
                    </>
                ) : (
                    <Routes>
                        <Route path="/" element={<Signin onLogin={handleLogin} />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/sign-up" element={<Signup onSignup={handleLogin} />} />
                        <Route path="/verify" element={<VerifyCode />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                )}
            </div>
        </Router>
    );
}

export default App;











































